import { useMemo } from 'react'

import {
  selectUsTrialFlag,
  selectCanadaTrialFlag,
  selectLatinoTrialFlag,
} from '../reducers/cohorts'
import { useSelector } from 'react-redux'

/**
 * Hook to get trial status for markets
 * @param {string} market - Optional market to get trial status for
 * @returns {boolean|Object} Trial status for specific market or all markets
 */
export const useIsTrial = (market) => {
  const isUSTrial = useSelector(selectUsTrialFlag)
  const isCanadaTrial = useSelector(selectCanadaTrialFlag)
  const isLatinoTrial = useSelector(selectLatinoTrialFlag)

  const isTrialMap = useMemo(
    () => ({
      us: isUSTrial,
      canada: isCanadaTrial,
      latino: isLatinoTrial,
      all: isUSTrial,
    }),
    [isUSTrial, isCanadaTrial, isLatinoTrial]
  )

  // Early return for specific market
  if (market) {
    return isTrialMap[market] ?? isTrialMap.us
  }

  // Return full map for all markets
  return isTrialMap
}
